<div class="row d-flex justify-content-center">
    <div class="col-lg-10 text-center">
        <h3>
            <span class="text-size-xl">🎉</span> <br />
            Wie geht es nun weiter?
        </h3>
        <p>
            Wir freuen uns riesig über deine Bewerbung! Im ersten Schritt wartet ein Online-Assessment auf dich. Bitte schau dir dazu zunächst unser Erklärvideo an:
        </p>
        <button (click)="openVideoModal()" class="btn btn-black-border mt-4">
            Video ansehen
        </button>
    </div>
</div>
<div class="row position-relative mt-5">
    <div class="process-line d-none d-lg-block"></div>
    <div class="col-lg-4 mt-4 mt-lg-5 d-flex flex-column text-center">
        <div class="process-step mx-auto">
            @if(isBrowser){
            <ng-lottie [options]="{ path: '/assets/lottie/assessment.json' }"></ng-lottie>
            }
        </div>
        <p class="mt-4">
            <b>1. Online-Assessment</b
            ><br />
            <span class="text-size-xs">ca. 25 Minuten</span>
        </p>
    </div>
    <div class="col-lg-4 mt-4 mt-lg-5 d-flex flex-column text-center">
        <div class="process-step mx-auto">
            @if (isBrowser){
            <ng-lottie [options]="{ path: '/assets/lottie/personal-data.json' }"></ng-lottie>
            }
        </div>
        <p class="mt-4">
            <b>2. Persönliche Angaben</b
            ><br />
            <span class="text-size-xs">ca. 2 Minuten</span>
        </p>
    </div>
    <div class="col-lg-4 mt-4 mt-lg-5 d-flex flex-column text-center">
        <div class="process-step mx-auto">
            @if (isBrowser) {
            <ng-lottie [options]="{ path: '/assets/lottie/live-interview.json' }"></ng-lottie>
            }
        </div>
        <p class="mt-4">
            <b>3. Persönliches Gespräch</b
            ><br />
            <span class="text-size-xs">ca. 30-60 Minuten</span>
        </p>
    </div>
    <div class="col-12 text-center mt-5">
        <a
            [href]="assessmentSessionUrl"
            target="_blank"
            rel="noopener nofollow"
            class="btn btn-black"
            id="start-assessment-session"
            (click)="trackEventStartAssessment()"
        >
            Online-Assessment starten
        </a>
    </div>
</div>
<div class="row d-flex justify-content-center mt-5 mt-lg-6">
    <div class="col-lg-10 text-center">
        <h4>Du hast gerade keine Zeit? ⏰</h4>
        <p>Kein Problem! Du bekommst automatisch eine E-Mail, über die du das Assessment jederzeit starten kannst. Falls du die E-Mail nicht sofort findest, schau am besten auch im Spam-Ordner nach.</p>
    </div>
</div>
